import { TICKET_STATUS, TICKET_STATUS_LABELS, TICKET_STATUS_COLORS } from '@/constants/status';
import { cn } from '@/lib/utils';

export const StatusBadge = ({ status, className }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-1 text-xs font-semibold uppercase tracking-wider border rounded-sm',
        TICKET_STATUS_COLORS[status] || 'bg-gray-100 text-gray-800',
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {TICKET_STATUS_LABELS[status] || status}
    </span>
  );
};

export const PriorityBadge = ({ priority, className }) => {
  const colors = {
    urgent: 'bg-red-500 text-white',
    normal: 'bg-yellow-500 text-white',
    low: 'bg-green-500 text-white',
  };
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-1 text-xs font-bold uppercase tracking-wider rounded-sm',
        colors[priority] || 'bg-gray-500 text-white',
        className
      )}
      data-testid={`priority-badge-${priority}`}
    >
      {priority}
    </span>
  );
};